import { PAGE_STATE_PRE_EVENT, PAGE_STATE_CHECK_IN, PAGE_STATE_DURING_EVENT } from 'common/constants/virtualEvent';
import Logger from 'observability/Logger';
import { transformPreEventStateData } from './stateTransformationFunctions/transformPreEventStateData';
import { transformCheckInStateData } from './stateTransformationFunctions/transformCheckInStateData';
import { transformDuringEventStateData } from './stateTransformationFunctions/transformDuringEventStateData';

const LOG = new Logger('convertLegacyToEngine-helper');

const allKnownStylesProperties = [
    'color',
    'textColor',
    'hover',
    'hoverTextColor',
    'background',
    'backgroundHover',
    'backgroundColor',
    'image',
    'family',
    'size',
    'width',
    'maxWidth',
    'buttonColor',
    'buttonColorHover',
    'buttonBackgroundColor',
    'buttonBackgroundColorHover',
    'buttonFontFamily',
    'buttonFontSize',
    'backgroundColorEmbed',
    'backgroundColorLinkOut',
    'headlineColor',
    'headlineFontSize',
    'headlineFontFamily',
    'zoomPreEventBackgroundColor',
    'zoomPreEventHeadlineColor',
    'zoomPreEventHeadlineFontSize',
    'zoomPreEventHeadlineFontFamily',
    'zoomPreEventButtonColor',
    'zoomPreEventButtonColorHover',
    'zoomPreEventButtonBackgroundColor',
    'zoomPreEventButtonBackgroundColorHover',
    'zoomPreEventButtonFontSize',
    'zoomPreEventButtonFontFamily',
];

const allKnownMetaProperties = [
    'layoutType',
    'logoType',
    'enabled',
    'href',
    'src',
    'image',
    'type',
    'buttonHref',
    'label',
    'buttonLabel',
    'headline',
    'zoomPreEventButtonLabel',
    'zoomPreEventHeadline',
];

export const allStylesMap = {
    color: 'fontColor',
    hover: 'fontColorHover',
    background: 'backgroundColor',
    backgroundHover: 'backgroundColorHover',
    image: 'backgroundImageUrl',
    family: 'fontFamily',
    size: 'fontSize',
    buttonColor: 'fontColor',
    buttonColorHover: 'fontColorHover',
    buttonBackgroundColor: 'backgroundColor',
    buttonBackgroundColorHover: 'backgroundColorHover',
    buttonFontFamily: 'fontFamily',
    buttonFontSize: 'fontSize',
    backgroundColorEmbed: 'backgroundColor', //  (descendent?)
    backgroundColorLinkOut: 'backgroundColor',
    headlineColor: 'fontColor',
    headlineFontSize: 'fontSize',
    headlineFontFamily: 'fontFamily',
    zoomPreEventBackgroundColor: 'backgroundColor',
    zoomPreEventHeadlineColor: 'fontColor',
    zoomPreEventHeadlineFontSize: 'fontSize',
    zoomPreEventHeadlineFontFamily: 'fontFamily',
    zoomPreEventButtonColor: 'fontColor',
    zoomPreEventButtonColorHover: 'fontColorHover',
    zoomPreEventButtonBackgroundColor: 'backgroundColor',
    zoomPreEventButtonBackgroundColorHover: 'backgroundColorHover',
    zoomPreEventButtonFontSize: 'fontSize',
    zoomPreEventButtonFontFamily: 'fontFamily',
};

export const EMPTY_BORDER_WIDTH = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
};

// Applies to both Header and Virtual Content layouts
export const layoutMap = {
    1: 'sideBySide',
    2: 'stacked',
    3: 'sidebar',
};

export const logoMap = {
    customLogo: 'custom',
    darkLogo: 'dark',
    lightLogo: 'light',
};

export const metaMap = {
    enabled: 'visible',
    buttonHref: 'href',
    type: 'virtualContentType',
};

export const stylesMapKeys = Object.keys(allStylesMap);
export const metaMapKeys = Object.keys(metaMap);

export function checkForUnknownKeys(properties, styles, element) {
    const propertiesKeys = Object.keys(properties);
    const stylesKeys = Object.keys(styles);
    const unknownPropertiesKeys = propertiesKeys.filter((key) => !allKnownMetaProperties.includes(key));
    const unknownStylesKeys = stylesKeys.filter((key) => !allKnownStylesProperties.includes(key));

    if (unknownPropertiesKeys.length) {
        LOG.error('[VEP-TO-CMS] Unknown Properties Key', { element, unknownPropertiesKeys });
    }

    if (unknownStylesKeys.length) {
        LOG.error('[VEP-TO-CMS] Unknown Styles Key', { element, unknownStylesKeys });
    }
}

export const transformerFunctionsMap = {
    [PAGE_STATE_PRE_EVENT]: transformPreEventStateData,
    [PAGE_STATE_CHECK_IN]: transformCheckInStateData,
    [PAGE_STATE_DURING_EVENT]: transformDuringEventStateData,
};
